import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'message_compose',
  })

  return function onClick() {
    submit({ type: 'sendInternal' })
  }
}
